/** Primary bot list URL: superadmin uses tenant hub; others use global /bots. */
export function getBotsListPath(
  tenantId: string | null | undefined,
  role: string | null | undefined
): string {
  const r = role?.toLowerCase();
  if (tenantId && r === 'superadmin') {
    return `/tenants/${tenantId}/bots`;
  }
  return '/bots';
}

/** When no tenant context (e.g. empty state): superadmin → tenant list; others → /bots. */
export function getBotsHomePath(role: string | null | undefined): string {
  return role?.toLowerCase() === 'superadmin' ? '/tenants' : '/bots';
}
